import './StaticPageById.scss';
import '../../assets/css/quill.snow.css';

import { useNavigate } from '@reach/router';
import moment from 'moment';
import React, { useMemo } from 'react';

import HEADERIMAGE from '../../assets/images/HeadersImages/PrivacyPolicy-Header.png';
import { useGetStaticPage } from '../../core/APIHooks/static';
import { ROUTES } from '../../pages/routes';
import HeaderLayout from '../HeaderLayout/HeaderLayout';
import StaticPageLoader from './StaticPageLoader';

export type StaticPageByIdProps = {
  id: number;
};

const StaticPageById = ({ id }: StaticPageByIdProps) => {
  const navigate = useNavigate();
  const { data: page, isLoading, isError } = useGetStaticPage(id);

  return useMemo(() => {
    if (isLoading) return <StaticPageLoader />;

    if (isError || !page || !page?.data.enabled) {
      navigate(ROUTES.NOTFOUND);
      return null;
    }

    const description = `Effective date: ${moment(page.data.effective_date).format(
      'Do MMMM YYYY'
    )}`;
    const image = HEADERIMAGE;

    return (
      <div className="StaticPage">
        <HeaderLayout title={page.data.title} description={description} image={image} />
        <div
          className="StaticPage-Container ql-editor"
          dangerouslySetInnerHTML={{ __html: page?.data.content || '' }}
        ></div>
      </div>
    );
  }, [isError, isLoading, navigate, page]);
};

export default StaticPageById;
